import { useMemo } from 'react';
import { useSubscriptions } from '../../subscriptions/hooks/useSubscriptions';

export type SubscriptionStatusInfo = {
    isSubscribed: boolean;
    activePriceIds: string[];
    subscriptionId: string | null;
    billingPeriod: string | null;
    amount: number | null;
};

export const useSubscriptionStatus = () => {
    const { items: subscriptions, loading } = useSubscriptions();

    const statusByProductId = useMemo(() => {
        const lookup: Record<string, SubscriptionStatusInfo> = {};

        subscriptions
            ?.filter(sub => sub.status === 'Active')
            ?.forEach(sub => {
                sub.items?.items?.forEach(item => {
                    const productId = item.price?.product?.id;
                    if (!productId) return;

                    if (!lookup[productId]) {
                        lookup[productId] = {
                            isSubscribed: true,
                            activePriceIds: [],
                            subscriptionId: sub.id,
                            billingPeriod: item.price?.billingPeriod || null,
                            amount: item.price?.amount || null,
                        };
                    }
                    lookup[productId].activePriceIds.push(item.priceId);
                });
            });

        return lookup;
    }, [subscriptions]);

    return { statusByProductId, loading };
};
